import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { DeheadingRatesEntity } from './deheading-rates-entity';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { DeheadingRatesController } from './deheading-rates-controller';
import { DeheadingRatesService } from './deheading-rates-service';

@Module({
    imports: [
        TypeOrmModule.forFeature([DeheadingRatesEntity])
    ],
    controllers: [DeheadingRatesController],
    providers: [DeheadingRatesService, ApplicationExceptionHandler],
    exports: [DeheadingRatesService]
})
export class DeheadingRatesModule {}
